import { render, staticRenderFns } from "./PdSalaryLane.vue?vue&type=template&id=741c2cc8&scoped=true&"
import script from "./PdSalaryLane.vue?vue&type=script&lang=js&"
export * from "./PdSalaryLane.vue?vue&type=script&lang=js&"
import style0 from "./PdSalaryLane.vue?vue&type=style&index=0&id=741c2cc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741c2cc8",
  null
  
)

export default component.exports